export default "/_next/static/chunks/fonts/FjallaOne-Regular-latin-8ab001930a69dea2465585b2fa646ad5.woff2";